var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wizard-step-persona-content"},[_c('div',{staticClass:"wizard-step-persona-content__flow"}),_vm._v(" "),_c('cms-rich-text',{attrs:{"rich-text":_vm.page.richText}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }